export default {
  name: "Dhivyaa M",
  feedback: `The class was excellent! Chef Ramya Mam explained everything clearly and gave us hands-on practice.
  I especially liked the hands-on practice — we got to bake cakes, make frosting, decorate them, and even try some advanced techniques. 
  Explains Each step by step clearly. Thank you Mam....`
};
